import { useEffect, useRef, useState, type FormEvent } from 'react'
import { localDate, type Objective, type ObjectiveDraft } from '../../domain/objective'
import { missionCopy } from '../missionCopy'
import { CloseIcon } from './Icons'
import { useI18n } from '../../i18n'

interface Props {
  objective: Objective | null
  open: boolean
  saving: boolean
  error: string | null
  onClose: () => void
  onSave: (draft: ObjectiveDraft) => Promise<boolean>
}

export const ObjectiveEditorSheet = ({ objective, open, saving, error, onClose, onSave }: Props) => {
  const { language, copy: { common, goalEditor } } = useI18n()
  const c = missionCopy[language]
  const dialogRef = useRef<HTMLDialogElement>(null)
  const [name, setName] = useState('')
  const [activate, setActivate] = useState(false)
  const [deadline, setDeadline] = useState('')
  useEffect(() => {
    const dialog = dialogRef.current
    if (!dialog) return
    if (open && !dialog.open) dialog.showModal()
    if (!open && dialog.open) dialog.close()
  }, [open])
  useEffect(() => { if (open) { setName(objective?.name ?? ''); setActivate(false); setDeadline(objective?.deadline ?? '') } }, [objective, open])
  const submit = async (event: FormEvent) => { event.preventDefault(); if (name.trim() && await onSave({ name: name.trim(), activate, deadline: deadline || null })) onClose() }
  return (
    <dialog ref={dialogRef} className="sheet objective-editor-sheet" onCancel={(event) => { event.preventDefault(); onClose() }} onClose={onClose}>
      <form className="sheet__body" onSubmit={submit}>
        <div className="sheet__handle" />
        <div className="sheet__heading"><div><h2>{objective ? goalEditor.edit : goalEditor.create}</h2>{!objective && <p>{goalEditor.intro}</p>}</div><button className="icon-button" type="button" onClick={onClose} aria-label={common.close}><CloseIcon /></button></div>
        <label className="field"><span>{goalEditor.goal}</span><input value={name} onChange={(event) => setName(event.target.value.slice(0, 80))} autoFocus /></label>
        <label className="field"><span>{c.deadline}</span><input type="date" value={deadline} min={objective?.deadline && objective.deadline < localDate() ? objective.deadline : localDate()} onChange={(event) => setDeadline(event.target.value)} /><small>{c.deadlineHelp}</small></label>
        {objective?.originalDeadline && <p className="mission-race__hint">{c.original}: {objective.originalDeadline}</p>}
        {!objective && <label className="check-row"><input type="checkbox" checked={activate} onChange={(event) => setActivate(event.target.checked)} /><span>{goalEditor.activate}</span></label>}
        {error && <div className="error-message" role="alert">{error}</div>}
        <button className="button button--primary" type="submit" disabled={!name.trim() || saving}>{saving ? common.saving : objective ? common.saveChanges : goalEditor.save}</button>
      </form>
    </dialog>
  )
}
